// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1e7e2a1b","879":"4e45fd05"}[chunkId] + ".chunk.js";
};